import $ from 'jquery'

import BaseComponent from 'scripts/components/base-component'

class Search extends BaseComponent {
  static componentName = 'search'

  static DOMEvents = {
    submit: 'onFormSubmit'
  }

  getFormValidation () {
    if (!this.validation) {
      this.validation = this.$element.data('validation')
    }
  }

  onFormSubmit (e) {
    this.getFormValidation()

    if (!this.validation.validateAll()) {
      return e.preventDefault()
    }
  }
}

export default ($el) => new Search($el)

export { Search as Component }
